import React from 'react';
import {AgGridColumn} from "../../../components/agGridColumn";
import Grid, {ListaMultiplaFilter} from '../../../components/grid';
import { ActionProps } from '../../../components/gridAction';
import {TypeMockupEnum} from "./index";
import enumDescription from "../../../services/enumDescription";
import {AtivoList} from "../../cadastros/usuario";

const MockupList = (props:any) => {

    const TypeListFormater = (params: any) => {
        return TypeMockupEnum.getDescription(params.value);
    }

    const situacaoListFormater = (params: any) => {
        let valor = params.value;
        if (valor === true) valor = 1;
        if (valor === false) valor = 0;
        return AtivoList.getDescription(Number(valor));
    }

    const actions: Array<ActionProps> = [
        {
            route:'mockup/incluir',
            color:'success',
            type:'normal',
            title:'Incluir'
        },
        {
            route:'mockup/alterar',
            color:'warning',
            type:'grid',
            title:'Alterar'
        },
        {
            route:'mockup/delete',
            color:'danger',
            type:'delete',
            title:'Excluir'
        },
        {
            route:'mockup/ativar-desativar',
            color:'primary',
            type:'post',
            title:'Ativar/Desativar'
        }
    ];

    return (
        <Grid actions={actions} rota="mockup/list">
            <AgGridColumn sort="desc" width={100} headerName="#" checkboxSelection field="id"  sortable={ true } filter={ 'agNumberColumnFilter'}></AgGridColumn>
            <AgGridColumn flex={1} minWidth={200} headerName="Nome" field="name"  sortable={ true } filter={ true }></AgGridColumn>
            <AgGridColumn minWidth={200} headerName="Tipo" field="type" sortable={ true } filter={ FiltroTipo } valueFormatter={TypeListFormater}></AgGridColumn>
            <AgGridColumn width={150} headerName="Situação" field="ativo" sortable={ true } filter={ FiltroAtivo } valueFormatter={situacaoListFormater} ></AgGridColumn>
        </Grid>
    );
};

class FiltroAtivo extends ListaMultiplaFilter{
    getList(): enumDescription {
        return AtivoList;
    }
}

class FiltroTipo extends ListaMultiplaFilter {
    getList(): enumDescription {
        return TypeMockupEnum;
    }
}

export default MockupList;